// extracted by mini-css-extract-plugin
export default {"MiddleRow":"Allfeed_MiddleRow__RLJ46"};